"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ChatMessage = _interopRequireDefault(require("./ChatMessage.scss"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _Chat = require("./Chat");

function ChatMessage(_ref) {
  var id = _ref.id,
      userId = _ref.userId,
      message = _ref.message,
      setQuotedMessage = _ref.setQuotedMessage,
      _ref$isExpert = _ref.isExpert,
      isExpert = _ref$isExpert === void 0 ? false : _ref$isExpert;

  function getDisplayedDate() {
    var date = message && message.date ? new Date(message.date) : new Date();
    var hours = date.getHours();

    if (hours < 10) {
      hours = "0".concat(hours);
    }

    var minutes = date.getMinutes();

    if (minutes < 10) {
      minutes = "0".concat(minutes);
    }

    return "".concat(hours, ":").concat(minutes);
  }

  var isMe = userId === message.userId;
  var specificClassName;

  if (message.isExpert) {
    specificClassName = _ChatMessage["default"].expert;

    if (isMe) {
      specificClassName = "".concat(_ChatMessage["default"].me, " ").concat(_ChatMessage["default"].expert);
    } else {
      specificClassName = "".concat(_ChatMessage["default"].others, " ").concat(_ChatMessage["default"].expert);
    }
  } else {
    if (isMe) {
      specificClassName = _ChatMessage["default"].me;
    } else {
      specificClassName = _ChatMessage["default"].others;
    }
  }

  var classNames = "".concat(_ChatMessage["default"].message, " ").concat(specificClassName);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatMessage["default"].outer
  }, message.type === _Chat.MESSAGE_TYPES.TEXT && /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames,
    id: id
  }, message.isExpert ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    className: _ChatMessage["default"].expertIcon,
    name: "star"
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatMessage["default"].name
  }, isMe ? 'Du' : message.isExpert ? "Experte ".concat(message.userName) : message.userName, ":"), message.quote ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatMessage["default"].quote
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatMessage["default"].name
  }, "Zitat ".concat(message.quote.userName, ":")), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatMessage["default"].text,
    dangerouslySetInnerHTML: {
      __html: message.quote.text.replace(/(\r\n|\n|\r)/gm, '<br />')
    }
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatMessage["default"].text,
    dangerouslySetInnerHTML: {
      __html: message.text.replace(/(\r\n|\n|\r)/gm, '<br />')
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatMessage["default"].date
  }, getDisplayedDate(message)), isExpert && !isMe ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    className: isExpert ? _ChatMessage["default"].quoteButtonExpert : _ChatMessage["default"].quoteButton,
    onClick: function onClick() {
      setQuotedMessage({
        userName: message.userName,
        text: message.text
      });
    },
    name: "quote-right"
  }) : null), message.type === _Chat.MESSAGE_TYPES.PRESENCE && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_ChatMessage["default"].message, " ").concat(_ChatMessage["default"].presenceMessage),
    id: id
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: message.isExpert ? {
      fontWeight: 'bold'
    } : {},
    className: _ChatMessage["default"].text,
    dangerouslySetInnerHTML: {
      __html: "".concat(getDisplayedDate(message), ": ").concat(message.text)
    }
  })));
}

ChatMessage.propTypes = {
  id: _propTypes["default"].string.isRequired,
  message: _propTypes["default"].object.isRequired,
  userId: _propTypes["default"].string.isRequired,
  setQuotedMessage: _propTypes["default"].func,
  isExpert: _propTypes["default"].bool
};
ChatMessage.defaultProps = {
  isExpert: false
};
var _default = ChatMessage;
exports["default"] = _default;